import * as React from 'react';
import {
    UitkText,
    UitkHeading
} from "@egencia/uitk-react";

export function NoSearchResults() {
    return (
        <div>
            <img 
                className="null-state-icon"
                src={`${EG.baseUrl}/images/no-reports.png`}
                alt={uitk.i18n.msg('no_results_found_alt_text')}
                style={{
                    width: "100%"
                }}
            />            
            <UitkHeading tag="h5" size="300">{uitk.i18n.msg("no_results_found_header")}</UitkHeading>
            <UitkText size={300} spacing="four">{uitk.i18n.msg("no_results_found_message")}</UitkText>
        </div>
    )
}